import { gql } from 'apollo-client-ppc';

export const fetchBillToAddressByTransactionAccountId = gql`
  query fetchBillToAddressByTransactionAccountId($id: ID!) {
    transactionAccount(id: $id) {
      billToParty {
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
        taxExempt
      }
    }
  }
`;
